// @givmo/board — the director's own "Sign-in & security" page (CBG-SEC2 SEC2-WEB).
//
// A director who isn't one of the organization's officers has no Settings page, so on the web they had
// nowhere to add or remove a passkey (Account Security's 1003a review). The account menu's row leads
// here instead.
//
// The card is Account Security's (A4, `@givmo/passkeys`' `SignInSecurityCard`), handed in by the host
// with its words. This page places them the way the other director pages place theirs: the title and
// line as the page's heading, the card beneath. It is about the account, not any one board, so it
// carries no `?org=`.
//
// While the card is dark it renders nothing, and the account menu offers no row leading here. A host
// with no card at all sends the director to their boards.

import { useEffect } from 'react';
import { useNavigate } from '../../board-routing';
import { BOARD_DIRECTOR_PAGES } from '../../board-routes';
import { useBoardDirectorHost } from '../../director/director-host';
import { DirectorShell } from './director-shell';

export function DirectorSignInSecurityPage() {
  const { account, signInSecurity } = useBoardDirectorHost();
  const navigate = useNavigate();
  const missing = signInSecurity === null;

  useEffect(() => {
    if (missing) void navigate({ to: BOARD_DIRECTOR_PAGES.home, replace: true });
    // `navigate` is a fresh closure each render; the redirect is decided by `missing` alone.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missing]);

  if (signInSecurity === null) return null;
  return (
    <DirectorShell
      title={signInSecurity.title}
      description={signInSecurity.description}
      // About the account, so the identity line names it, as "Your boards" does.
      identity={account?.displayName ?? account?.email ?? undefined}
      testId="page-director-sign-in-security"
    >
      {signInSecurity.render()}
    </DirectorShell>
  );
}
